document.addEventListener('turbo:load', () => {
  const navHeader = document.getElementById('app-header-wrapper')

  if (navHeader) {
    navHeader.addEventListener('toggle:show', () => {
      document.body.classList.add('fixed')
    })

    navHeader.addEventListener('toggle:hide', () => {
      document.body.classList.remove('fixed')
    })
  }
})
